/**
 * Created by hp on 2017/8/16.
 */
import AideCard from './AideCard';
import AideDialog from './AideDialog';

export {
    AideCard,
    AideDialog,
}



// WEBPACK FOOTER //
// ./src/components/common/index.js